/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { Nullable, Setter } from "../../utils/Interfaces";
import { convertHeaderDateTimes, toUTC } from "../../utils/Functions";

function formatDate(date: Nullable<string | Date>) {
    if (!date) {
        return "--";
    }

    let d: Date = toUTC(new Date(date));

    let dateFmt = "";

    let mins: number = d.getMinutes();
    let hrs: number = d.getHours();

    let minsStr: string = "";

    if (mins < 10) {
        minsStr = `0${mins}`;
    } else {
        minsStr = mins.toString();
    }

    let ampm = "AM";

    if (hrs > 12) {
        hrs -= 12;
        ampm = "PM";
    } else if (hrs === 12) {
        ampm = "PM";
    } else if (hrs === 0) {
        hrs = 12;
    }

    dateFmt = `${d.toLocaleDateString()} ${hrs}:${minsStr} ${ampm}`;

    return dateFmt;
}

export interface TimeRowProps {
    editing: boolean;
    field: Nullable<string>;
    setField: Setter<Nullable<string>>;
    label: string;
}

const TimeRow = (props: TimeRowProps) => {
    const { editing, field, setField, label } = props;

    return (
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Typography sx={{ fontSize: 18 }} color="text.primary">
                {label}
            </Typography>
            {!editing && (
                <Typography sx={{ fontSize: 18 }} color="text.primary" variant="overline">
                    {field !== undefined && field !== null ? formatDate(field) : "--"}
                </Typography>
            )}

            {editing && (
                <TextField
                    id="date_row"
                    label={label}
                    type="datetime-local"
                    value={field}
                    onChange={(event) => setField(event.target.value + ":00")}
                    size="small"
                    fullWidth
                    inputProps={{
                        step: 60,
                    }}
                />
            )}
        </Grid>
    );
};

export default TimeRow;
